import * as React from 'react';
import {translate} from "react-i18next";

import {compose} from 'redux';
import {Icon} from 'semantic-ui-react';
import {ITranslatedComponent} from 'src/redux/reducers/generalReducer';
import MainTiles from './MainTiles';

interface ISlideFromTop extends ITranslatedComponent {
    isTopSlideVisible:boolean | undefined;
 }

interface ISlideFromTopState {
    isVisible: boolean;
}

class SlideFromTop extends React.Component<ISlideFromTop, ISlideFromTopState> {
    constructor(props: ISlideFromTop) {
        super(props);
        this.state = {isVisible: false};
    }

    handleShowMenu = () => this.setState(() => ({isVisible: !this.state.isVisible}));

    handleHideMenu = (event: any) => {
        event.stopPropagation();
        this.setState(() => ({isVisible: false}));
    }

    render() {
        const {isVisible} = this.state;
        const {t} = this.props;

        return (
            <>
                <div
                    className={`overlay-top ${isVisible ? 'navToggle' : ''}`}
                    onClick={this.handleHideMenu}
                >
                    {
                        (isVisible && this.props.isTopSlideVisible) &&
                        <div className='slide-from-top' >
                            <div className='start-view-grid-top-menu'>
                                {/*
                                // @ts-ignore */}
                                <MainTiles  isFromTop={true}/>
                            </div>
                            <div className="bottom-tooltip close-menu-tooltip">
                                <Icon name='angle double up' className="close-menu" onClick={this.handleShowMenu} />
                                <span className="tooltiptext">{t("CLOSE_MENU")}</span>
                            </div>
                        </div>
                    }
                </div>
                {this.props.isTopSlideVisible && <div className="bottom-tooltip open-menu-tooltip">
                    <Icon name='angle double down' className="open-menu" onClick={this.handleShowMenu} />
                    <span className="tooltiptext">{t("OPEN_MENU")}</span>
                </div> }
            </>
        );
    }
}

export default compose(
    translate(["START_VIEW", "SIDEBAR"]),
)(SlideFromTop);



// WEBPACK FOOTER //
// ./src/components/NavLink/SlideFromTop.tsx